import {
  CheckboxField,
  RadioField,
  SingleSelectField,
  TextField,
} from "components/RenderInput"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, FieldArray } from "redux-form"
import ReactDragListView from "react-drag-listview/lib/ReactDragListView"
import React from "react"

export const renderForm = (type, isMulti, link) => {
  switch (type) {
    case "2":
      return (
        <React.Fragment>
          <Row className="my-3">
            <Col>
              <Field
                name={isMulti ? `${link}.IOSdeeplink` : "IOSdeeplink"}
                component={TextField}
                label="IOS deeplink"
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <Field
                name={isMulti ? `${link}.appStoreLink` : "appStoreLink"}
                component={TextField}
                label="App Store link"
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <Field
                name={isMulti ? `${link}.androidDeeplink` : "androidDeeplink"}
                component={TextField}
                label="Android deeplink"
              />
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <Field
                name={isMulti ? `${link}.googleStoreLink` : "googleStoreLink"}
                component={TextField}
                label="Google Play Store link"
              />
            </Col>
          </Row>
        </React.Fragment>
      )
    case "3":
      return (
        <React.Fragment>
          <Row className="my-3">
            <Col>
              <Field
                name={isMulti ? `${link}.phoneNumber` : "phoneNumber"}
                component={TextField}
                label="Phone Number"
                normalize={value => value.replace(/[^0-9]+/g, "")}
              />
            </Col>
          </Row>
        </React.Fragment>
      )
    default:
      return (
        <React.Fragment>
          <Row className="my-3">
            <Col>
              Cut and paste the URL below. Make sure to include http:// or
              https://
            </Col>
          </Row>
          <Row className="my-3">
            <Col>
              <Field
                name={isMulti ? `${link}.webUrl` : "webUrl"}
                component={TextField}
                label="Website URL"
              />
            </Col>
          </Row>
          {!isMulti && (
            <Row className="my-3">
              <Col>
                <Field
                  name="externalBrowser"
                  component={CheckboxField}
                  label="Open in External Browser"
                />
              </Col>
            </Row>
          )}
          <Row className="my-3">
            <Col xs={12}>
              <Field
                name={isMulti ? `${link}.browserOption` : "browserOption"}
                fullWidth={true}
                component={SingleSelectField}
                placeholder="No browser controls"
                options={[
                  { value: "0", label: "No browser controls" },
                  {
                    value: "1",
                    label: "Top Browser Bar with address bar",
                  },
                  { value: "2", label: "Bottom browser buttons" },
                ]}
              />
            </Col>
          </Row>
        </React.Fragment>
      )
  }
}

export const renderMultiWebLinkForm = ({ fields, menuIcons }) => {
  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      fields.swap(fromIndex, toIndex)
    },
    nodeSelector: "div.card",
    handleSelector: "div.card",
    lineClassName: "dragDropLine",
  }
  return (
    <ReactDragListView {...dragProps}>
      {fields.map((link, index) => {
        const formValues = fields.get(index)
        return (
          <Card key={index}>
            <CardHeader>
              <Row>
                {fields.length > 1 && (
                  <Col xs="auto">
                    <i
                      className="bx bx-sm bx-menu"
                      style={{
                        cursor: "pointer",
                      }}
                    />
                  </Col>
                )}
                <Col style={{ display: "inline" }}>
                  <h5
                    style={{ display: "inline", verticalAlign: "text-bottom" }}
                  >
                    CREATE A NAME FOR THE WEB LINK AND ADD A WEB URL, PHONE
                    NUMBER OR DEEPLINK
                  </h5>
                </Col>
                {fields.length > 2 && (
                  <Col xs="auto" style={{ display: "inline" }}>
                    <i
                      className="bx bx-sm bx-trash"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        fields.remove(index)
                      }}
                    />
                  </Col>
                )}
              </Row>
            </CardHeader>
            <CardBody>
              <Row className="mb-3">
                <Col>
                  <Field
                    name={`${link}.name`}
                    component={TextField}
                    label="Web link Name"
                  />
                </Col>
              </Row>
              <hr />
              <Row>
                <Col>
                  <Field
                    name={`${link}.linkType`}
                    value="1"
                    type="radio"
                    label="Website URL"
                    component={RadioField}
                  />
                </Col>
                <Col>
                  <Field
                    name={`${link}.linkType`}
                    value="2"
                    type="radio"
                    label="IOS/Android deeplink"
                    component={RadioField}
                  />
                </Col>
                <Col>
                  <Field
                    name={`${link}.linkType`}
                    value="3"
                    type="radio"
                    label="Phone"
                    component={RadioField}
                  />
                </Col>
              </Row>
              {renderForm(formValues?.linkType, true, link)}
              <hr />
              <Row className="mt-3">
                <Col>
                  <label>Add an Icon for your Web link:</label>
                </Col>
              </Row>
              <Row>
                <Col xs={12}>
                  <div>
                    {menuIcons.map(icon => (
                      <label key={icon.id}>
                        <Field
                          name={`${link}.linkIcon`}
                          component="input"
                          type="radio"
                          value={icon.id}
                          style={{ position: "absolute", opacity: "0" }}
                        />
                        <img
                          src={icon.url}
                          style={
                            parseInt(formValues.linkIcon) === icon.id
                              ? {
                                  width: "30px",
                                  height: "auto",
                                  cursor: "pointer",
                                  margin: "4px",
                                  border: "1px solid red",
                                }
                              : {
                                  width: "30px",
                                  height: "auto",
                                  cursor: "pointer",
                                  margin: "4px",
                                }
                          }
                        />
                      </label>
                    ))}
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        )
      })}
    </ReactDragListView>
  )
}
